import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface AppState {
  loading: boolean
  message?: string | undefined
}

const initialState: AppState = {
  loading: false,
}

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    loading: (state, action: PayloadAction<string | undefined>) => {
      state.loading = true
      state.message = action.payload
    },
    stopLoading: (state) => {
      state.loading = false
      state.message = ''
    }
  },
})

// Action creators are generated for each case reducer function
export const { loading, stopLoading } = appSlice.actions

export default appSlice.reducer